import { render, staticRenderFns } from "./SporBahisIslemleri.vue?vue&type=template&id=e0738956&scoped=true"
import script from "./SporBahisIslemleri.vue?vue&type=script&lang=js"
export * from "./SporBahisIslemleri.vue?vue&type=script&lang=js"
import style0 from "./SporBahisIslemleri.vue?vue&type=style&index=0&id=e0738956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0738956",
  null
  
)

export default component.exports